import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { UserImportService } from '../services/userimport.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-heroma-importer',
  templateUrl: './heroma-importer.component.html',
  styleUrls: ['./heroma-importer.component.css']
})
export class HeromaImporterComponent {
  public form: UntypedFormGroup;
  public currentDate: Date;
  public dateFormControl = new UntypedFormControl();
  public importing: boolean = false;

  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly dialogRef: MatDialogRef<HeromaImporterComponent>,
    private readonly toastr: ToastrService,
    private readonly userimportService: UserImportService) {
    this.form = this.fb.group({
      dateFormControl: this.dateFormControl,
    });
  }

  public submit() {
    this.dialogRef.close();
  }

  public canSave() {
    return !this.form.invalid;
  }

  public import() {
    this.importing = true;
    this.currentDate = new Date(this.dateFormControl.value)

    this.userimportService.importWorkshiftForDate(this.currentDate).then((a => {
      this.toastr.success("Import genomförd!")
    })).catch((err: HttpErrorResponse) => {
      this.toastr.error(err.error);
    }).finally(() => this.importing = false);
  }
}
